import * as React from 'react';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { Check } from 'lucide-react';

import { cn } from '@/shared/lib/tailwind-merge';

interface BaseCheckboxProps extends React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root> {
    label?: React.ReactNode;
}

export const BaseCheckbox = React.forwardRef<
    React.ElementRef<typeof CheckboxPrimitive.Root>,
    BaseCheckboxProps
>(({ className, label, ...props }, ref) => (
    <div className='flex items-center space-x-2 gap-2'>
        <CheckboxPrimitive.Root
            ref={ref}
            className={cn(
                'peer h-6 w-6 srink-0 rounded-[4px] border border-background-alwaysDark focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring',
                'disabled:opacity-50 disabled:cursor-not-allowed',
                'hover:bg-background-secondary data-[state=checked]:bg-background-alwaysDark data-[state=checked]:border-none',
                'disabled:hover:border-opaque',
                className,
            )}
            {...props}
        >
            <CheckboxPrimitive.Indicator
                className={cn('flex items-center justify-center text-white gap-2')}
            >
                <Check className='h-[14px] w-[14px]' />
            </CheckboxPrimitive.Indicator>
        </CheckboxPrimitive.Root>
        {label}
    </div>
));
BaseCheckbox.displayName = CheckboxPrimitive.Root.displayName;
